<form nz-form [formGroup]="form">
    <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{'Layout.OldPwd'|translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="'Layout.OldPwd' | translate | requiredMessage">
            <input nz-input formControlName="currentPassword" type="password" [maxLength]="200">
            <!--<ng-template #getOldPasswordErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                    {{'Layout.OldPwdNotEmpty'|translate}}
                </ng-container>
            </ng-template>-->
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{'Layout.NewPwd'|translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="'Layout.NewPwd' | translate | requiredMessage" >
            <input nz-input formControlName="newPassword" type="password" [maxLength]="200">
            <!--<ng-template #getNewPasswordErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                    {{'Layout.NewPwdNotEmpty'|translate}}
                </ng-container>
            </ng-template>-->
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{'Layout.ConfirmPwd'|translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="getConfirmPasswordErrorTpl" >
            <input nz-input formControlName="confirmPassword" type="password" [maxLength]="200">
            <ng-template #getConfirmPasswordErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                    {{'Layout.ConfirmPwd'|translate|requiredMessage}}
                </ng-container>
                <ng-container *ngIf="control.hasError('compare')">
                    {{'Layout.ConfirmPwdNotSame'|translate}}
                </ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item>

</form>
<div *nzModalFooter>
    <button (click)="cancel()" type="button" nz-button>{{'Common.Cancel'|translate}}</button>
    <button (click)="save()" nz-button nzType="primary" [disabled]="form.invalid">{{'Common.Save'|translate}}</button>
</div>
